import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const issuesImporterSelectors = importerSelectors(
  'issues.importer',
);

export default issuesImporterSelectors;
